/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import PropTypes from "prop-types";
import React from "react";
import { FormGroup, Label } from "reactstrap";
import ValidationService from "../../../../service/ValidationService";
import SubmitButton from "../../../layout/Form/SubmitButton";
import ModalCardBody from "../../../layout/Modal/ModalCardBody";
import ModalCardFooter from "../../../layout/Modal/ModalCardFooter";
import SendMessageSelectRecipients from "./SendMessageSelectRecipients";

const SendMessageSelectRecipientsForm = ({
    form,
    institution,
    validation,
    isValid,
    selectParticipant
}) => (
    <React.Fragment>
        <ModalCardBody>
            <FormGroup className={"mb-0"}>
                <Label for="sectors">
                    Select up to two preferred recipients
                </Label>
                <div>
                    <SendMessageSelectRecipients
                        recipients={form.recipients}
                        validation={ValidationService.getFieldValidation(
                            validation,
                            "recipients"
                        )}
                        institution={institution}
                        selectParticipant={selectParticipant}
                    />
                </div>
            </FormGroup>
        </ModalCardBody>
        <ModalCardFooter>
            <SubmitButton
                disabled={!isValid}
                fieldName={"submit"}
                label={"Send"}
                className={"float-right"}
            />
        </ModalCardFooter>
    </React.Fragment>
);

SendMessageSelectRecipientsForm.propTypes = {
    form: PropTypes.object.isRequired,
    step: PropTypes.string.isRequired,
    institution: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    isValid: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    selectParticipant: PropTypes.func.isRequired,
    deal: PropTypes.object
};

export default SendMessageSelectRecipientsForm;
